import React, { Component, Fragment } from "react";
import {
  DataGrid,
  Dialog,
  Form,
  FormField,
  GridColumn,
  Layout,
  LayoutPanel,
  LinkButton,
  Panel,
  TextBox,
  TimePicker,
} from "rc-easyui";
import { Col } from "react-bootstrap";
import "./index.scss";
import { uAPI } from "../config/Config";
import axios from "axios";
import { createWorker } from "tesseract.js";
import "filepond/dist/filepond.min.css";
import moment from "moment";


function getAge(DOB) {
  var today = new Date();
  var birthDate = new Date(DOB);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age = age - 1;
  }

  return age;
}

class Reminder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: this.props.login,
      detail_login: this.props.detail_login,
      loading: false,
      error: false,
      reminder: {
        total: 0,
        pageSize: 20,
        data: [],
        pagePosition: "bottom",
        pageOptions: {
          layout: [
            "list",
            "sep",
            "first",
            "prev",
            "next",
            "last",
            "sep",
            "refresh",
            "sep",
            "manual",
            "info",
          ],
        },
        selection: null,
      },
      formReminder: {
        field: {
          hari: "",
        },
        rules: {
          hari: ["required"],
        },
      },
      editReminder: {
        field: {
          hari: "",
        },
        rules: {
          hari: ["required"],
        },
      },
      patient_id: "",
    };

    this.selectionChange = this.selectionChange.bind(this);
    this.addReminder = React.createRef();
    this.updateReminder = React.createRef();
    this.handleChangeFormReminder = this.handleChangeFormReminder.bind(this);
    this.handleSubmitFormReminder = this.handleSubmitFormReminder.bind(this);
    this.handleConvertHours = this.handleConvertHours.bind(this);
    this.handleChangeEditReminder = this.handleChangeEditReminder.bind(this);
    this.handleSubmitEditReminder = this.handleSubmitEditReminder.bind(this);
    this.getData_ = this.getData_.bind(this);
    this.deleteData = this.deleteData.bind(this);
  }

  async handleChangeFormReminder(name, value) {
    let field = Object.assign({}, this.state.formReminder.field);
    field[name] = value;
    await this.setState(
      {
        formReminder: {
          ...this.state.formReminder,
          field: field,
        },
      },
      () => console.log(this.state.formReminder)
    );
  }
  
  async handleSubmitFormReminder() {
    const formData = new FormData();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    // var d = new Date("1/1/1945 " + this.state.formReminder.field.hari);
    // var hari = d.getHours() + ":" + ("0" + d.getMinutes()).slice(-2);
    // formData.append("hari", jam_mulai);
    formData.append("hari", this.state.formReminder.field.hari);
    await axios
      .post(uAPI + "/api/v1/simpanRm", formData, config)
      .then((response) => {
        console.log(response);
        this.getData();
        this.addReminder.current.close();
        this.setState({
          formReminder: {
            ...this.state.formReminder,
            field: {
              hari: "",
            },
          },
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  handleConvertHours() {
    let h = moment(this.state.kuota.selection.jam_mulai, "H:mm")
      .locale("en")
      .format("h:mm a");
    return h;
  }

  async handleChangeEditReminder(name, value) {
    let field = Object.assign({}, this.state.editReminder.field);
    field[name] = value;
    await this.setState(
      {
        editReminder: {
          ...this.state.editReminder,
          field: field,
        },
      },
      () => console.log(this.state.editReminder)
    );
  }

  async handleSubmitEditReminder() {
    const formData = new FormData();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    // var d = new Date("1/1/1945 " + this.state.editReminder.field.jam_mulai);
    // var jam_mulai = d.getHours() + ":" + ("0" + d.getMinutes()).slice(-2);
    formData.append("id_reminder", this.state.reminder.selection.id_reminder);
    formData.append("hari", this.state.editReminder.field.hari);
    //alert(this.state.reminder.selection.id_reminder + "---" +this.state.editReminder.field.hari)
    // formData.append("kuota", this.state.editReminder.field.kuota);
    await axios
      .post(uAPI + "/api/v1/updateRm", formData, config)
      .then((response) => {
        console.log(response);
        this.getData();
        this.updateReminder.current.close();
        this.setState({
          editReminder: {
            ...this.state.editReminder,
            field: {
              hari: "",
            },
          },
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async removeToReminder() {
    const formData = new FormData();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    formData.append("id_reminder", this.state.reminder.selection.id_reminder);
    await axios
      .post(uAPI + "/api/v1/deleteRm", formData, config)
      .then((response) => {
        console.log(response);
        this.getData();
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // edit
  getData_() {
    if (this.state.reminder.selection) {
      this.updateReminder.current.open();
      this.setState({
        editReminder: {
          field: {
            // hari: moment(this.state.reminder.selection.hari, "H:mm")
            //   .locale("en")
            //   .format("h:mm a"),
            hari: this.state.reminder.selection.hari,
          },
        },
      });
    } else {
      alert("Pilih reminder yang akan diubah!");
    }
  }
  //hapus
  deleteData() {
    if (this.state.reminder.selection) {
      if (
        window.confirm(
          "Apakah anda yakin menghapus reminder " + 
            this.state.reminder.selection.hari +
            "?"
        )
      ) {
        this.removeToReminder();
      }
    } else {
      alert("Pilih reminder yang akan dihapus!");
    }
  }

  async getData() {
    await axios
      .get(uAPI + "/api/v1/listreminder")
      .then(function (response) {
        var input = response.data.results;
        input.sort(function (a, b) {
          if (
            Number(moment(a.hari, "H").format("H")) <
            Number(moment(b.hari, "H").format("H"))
          )
            return -1;
          if (
            Number(moment(a.hari, "H").format("H")) >
            Number(moment(b.hari, "H").format("H"))
          )
            return 1;
          return 0;
        });
        return input;
      })
      .then((response) => {
        console.log(response);
        this.setState({
          reminder: {
            ...this.state.reminder,
            data: response,
            loading: false,
          },
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  updateProgressAndLog(m) {
    // Maximum value out of which percentage needs to be
    // calculated. In our case it's 0 for 0 % and 1 for Max 100%
    // DECIMAL_COUNT specifies no of floating decimal points in our
    // Percentage
    var MAX_PARCENTAGE = 1;
    var DECIMAL_COUNT = 2;

    if (m.status === "recognizing text") {
      var pctg = (m.progress / MAX_PARCENTAGE) * 100;
      this.setState({
        pctg: pctg.toFixed(DECIMAL_COUNT),
      });
    }
  }

  async selectionChange(event) {
    // console.log(event)
    await this.setState(
      {
        reminder: {
          ...this.state.reminder,
          selection: event,
        },
      },
      () => console.log(this.state.reminder.selection.id_reminder)
    );
  }

  async componentDidMount() {
    this.getData();
    

    this.worker = createWorker({
      logger: (m) => this.updateProgressAndLog(m),
    });
  }

  render() {
    return (
      <>
        <Col md={6} style={{ marginLeft: "30px" }}>
          <Layout style={{ width: "100%", height: "100%" }}>
            <LayoutPanel
              region="center"
              title="Reminder"
              style={{ height: "100%" }}
            >
              <Panel bodyStyle={{ padding: "0px" }}>
                <LinkButton
                  iconCls="icon-add"
                  plain
                  onClick={() => this.addReminder.current.open()}
                >
                  Tambah Reminder
                </LinkButton>
                <LinkButton
                  iconCls="icon-edit"
                  plain
                  onClick={() => this.getData_()}
                >
                  Edit Reminder
                </LinkButton>
                <LinkButton
                  iconCls="icon-remove"
                  plain
                  onClick={() => this.deleteData()}
                >
                  Hapus Reminder
                </LinkButton>
              </Panel>

              <DataGrid
                style={{ height: "100%", width: 400 }}
                {...this.state.reminder}
                selectionMode="single"
                selection={this.state.reminder.selection}
                onSelectionChange={this.selectionChange}
                onPageChange={this.pageChange}
                columnResizing
                filterable
                virtualScroll
                columnMoving
              >
                <GridColumn
                  field="rn"
                  align="center"
                  width="5px"
                  cellCss="datagrid-td-rownumber"
                  filterable={false}
                  render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
                />
                <GridColumn
                  field="hari"
                  title="Hari"
                  align="center"
                  sortable
                  width="20px"
                  render={({ row }) => (
                    <div style={{ padding: "4px 0" }}>
                      <div style={{ fontWeight: "bold" }}>{row.hari}</div>
                      {/* <Clipboard data-clipboard-text={row.jam_mulai}>
                        copy
                      </Clipboard> */}
                    </div>
                  )}
                />
              </DataGrid>
            </LayoutPanel>
          </Layout>
        </Col>

        <Dialog
          title="Tambah Reminder"
          style={{ width: "400px", height: "400px", top: "30%" }}
          modal
          closed={true}
          draggable
          ref={this.addReminder}
        >
          <div className="pd-20">
            <h3 className="text-center">Tambah Reminder</h3>

            <Form
              ref={this.formReminder}
              style={{ maxWidth: 500 }}
              model={this.state.formReminder.field}
              rules={this.state.formReminder.rules}
              labelWidth={120}
              // labelAlign="right"
              labelPosition="top"
              //floatingLabel
              // validateRules={this.getCustomRules}
              onChange={this.handleChangeFormReminder}
            >
            

              <FormField name="hari" label="Hari:">
                <p>format yyyy-mm-dd</p>
              <TextBox
                  value={this.state.formReminder.hari}
                ></TextBox>
              </FormField>

              <FormField>
                <LinkButton onClick={this.handleSubmitFormReminder}>
                  Submit
                </LinkButton>
              </FormField>
            </Form>
          </div>
        </Dialog>

        {/* stay */}
        <Dialog
          title="Edit Hari"
          style={{ width: "400px", height: "400px", top: "30%" }}
          modal
          closed={true}
          draggable
          ref={this.updateReminder}
        >
          <div className="pd-20">
            <h3 className="text-center">Edit Hari</h3>

            <Form
              ref={this.editReminder}
              style={{ maxWidth: 500 }}
              model={this.state.editReminder.field}
              rules={this.state.editReminder.rules}
              labelWidth={120}
              // labelAlign="right"
              labelPosition="top"
              //floatingLabel
              // validateRules={this.getCustomRules}
              onChange={this.handleChangeEditReminder}
            >
              {/* <FormField name="hari" label="Jam Mulai:">
                <TimePicker
                  placeholder="Jam Mulai"
                  name="hari"
                  value={
                    this.state.reminder.selection ? this.handleConvertHours() : ""
                  }
                  panelStyle={{ width: 200, height: 300 }}
                />
              </FormField> */}
              
              <FormField name="hari" label="hari format yyyy-mm-dd:">
              <TextBox
                  value={
                    this.state.reminder.selection
                      ? this.state.reminder.selection.hari
                      : ""
                  }
                ></TextBox>
              </FormField>

              <FormField>
                <LinkButton onClick={this.handleSubmitEditReminder}>
                  Submit
                </LinkButton>
              </FormField>
            </Form>
          </div>
        </Dialog>
      </>
    );
  }
}
export default Reminder;
